import { createContext, useContext, useState, useCallback, useEffect } from 'react'

const LanguageContext = createContext()

export const useLanguage = () => useContext(LanguageContext)

const getLangFromUrl = () => {
	if (typeof window === 'undefined') return null
	const params = new URLSearchParams(window.location.search)
	const lang = params.get('lang')
	return lang === 'es' || lang === 'en' ? lang : null
}

const updateUrlLang = (lang) => {
	if (typeof window === 'undefined') return
	const url = new URL(window.location.href)
	url.searchParams.set('lang', lang)
	window.history.replaceState(null, '', url.toString())
}

export const LanguageProvider = ({ children }) => {
	const [language, setLanguageState] = useState(() => {
		return getLangFromUrl() || localStorage.getItem('portfolio-lang') || 'es'
	})

	useEffect(() => {
		document.documentElement.lang = language === 'es' ? 'es-MX' : 'en-US'
	}, [language])

	const setLanguage = useCallback((next) => {
		if (next !== 'es' && next !== 'en') return
		localStorage.setItem('portfolio-lang', next)
		updateUrlLang(next)
		setLanguageState(next)
	}, [])

	const toggleLanguage = useCallback(() => {
		setLanguageState((prev) => {
			const next = prev === 'es' ? 'en' : 'es'
			localStorage.setItem('portfolio-lang', next)
			updateUrlLang(next)
			return next
		})
	}, [])

	return (
		<LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
			{children}
		</LanguageContext.Provider>
	)
}
